// cart-drawer-logic.js

// Global binding so other scripts (Liquid inline, cart-gifts.js) can use it
var cartDrawer;

// Persistent visitor ID for upsell attribution (survives page reloads)
function getVisitorId() {
  var key = '_da_vid';
  try {
    var id = localStorage.getItem(key);
    if (!id) {
      id = 'da_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem(key, id);
    }
    return id;
  } catch (e) {
    return 'da_' + Math.random().toString(36).slice(2);
  }
}

/**
 * Toggle the coupon form open/closed (used by the "Have a coupon code?" link)
 */
function toggleDiscountForm() {
  var discountForm = document.querySelector('.discount-form-wrapper');
  if (!discountForm) return;
  discountForm.classList.toggle('open');
}

/**
 * Attach submit handler to the coupon form inside the drawer.
 * We call this from CartDrawer.init() after each render.
 *
 * Note: this relies on `refreshCartDrawer` defined in cart-gifts.js
 * for doing a full drawer section reload after a coupon is applied.
 */
function bindDiscountForm() {
  var discountForm = document.getElementById('cart-drawer-discount-form');
  var discountInput = document.getElementById('cart-discount-input');
  var applyButton = document.getElementById('apply-discount');
  var messageContainer = document.getElementById('discount-message');

  if (!discountForm) return;

  // Avoid binding twice on the same form element
  if (discountForm.__bound) return;
  discountForm.__bound = true;

  function showDiscountMessage(msg, type) {
    if (!messageContainer) return;
    messageContainer.innerText = msg;
    messageContainer.style.color =
      type === 'error' ? 'red' :
        type === 'success' ? 'green' :
          '';
  }

  discountForm.addEventListener('submit', function (e) {
    e.preventDefault();

    var discountCode = (discountInput && discountInput.value || '').trim();
    if (!discountCode) {
      showDiscountMessage('Please enter a coupon code', 'error');
      return;
    }

    showDiscountMessage('Applying coupon...');
    if (applyButton) applyButton.disabled = true;

    var originalCartTotal = 0;

    (async function applyCoupon() {
      try {
        // Get cart total before applying coupon
        var cartBeforeRes = await fetch('/cart.js', {
          credentials: 'same-origin',
          cache: 'no-store'
        });
        var cartBeforeData = await cartBeforeRes.json();
        originalCartTotal = cartBeforeData.total_price;

        // Hit Shopify's /discount endpoint (will affect the session)
        await fetch('/discount/' + encodeURIComponent(discountCode) + '?redirect=/cart', {
          method: 'GET',
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          cache: 'no-store'
        });

        // Give Shopify a moment to apply the code server-side
        setTimeout(async function () {
          var cartRes = await fetch('/cart.js', {
            credentials: 'same-origin',
            cache: 'no-store'
          });
          var cartData = await cartRes.json();

          var newTotal = cartData.total_price;
          var appliedDiscounts = cartData.discount_codes || [];
          var validCode = appliedDiscounts.some(function (d) {
            return (d.code || '').toLowerCase() === discountCode.toLowerCase();
          });
          var discountReal = validCode && newTotal < originalCartTotal;

          if (discountReal) {
            showDiscountMessage('Coupon applied successfully!', 'success');
            if (discountInput) discountInput.value = '';
            var wrapper = document.querySelector('.discount-form-wrapper');
            if (wrapper) wrapper.classList.remove('open');

            // Full drawer refresh (non-silent: we DO want cart:updated here)
            if (typeof refreshCartDrawer === 'function') {
              await refreshCartDrawer();
            }

            if (typeof window.checkAndAddVipGift === 'function') {
              await window.checkAndAddVipGift();
            }
            if (typeof window.checkFreeGift === 'function') {
              window.checkFreeGift(cartData);
            }

            // ❌ Cuban gift call removed (we no longer add Cuban)
          } else {
            showDiscountMessage('Invalid coupon code.', 'error');
          }

          if (applyButton) applyButton.disabled = false;
          if (typeof cartDrawer !== 'undefined') {
            cartDrawer.classList.remove('loading');
          }
        }, 1200);
      } catch (err) {
        console.error(err);
        showDiscountMessage('Something went wrong. Please try again.', 'error');
        if (applyButton) applyButton.disabled = false;
      }
    })();
  });
}

// Add these helper functions BEFORE the bindRemoveCoupon function
// in cart-drawer-logic.js

/**
 * Record all real items in the cart (excluding gifts, shipping protection, etc.)
 * Returns array of items with variant_id, quantity, and properties
 */
async function recordRealItems() {
  var VIP_GIFT_VARIANT_ID = 55521574617412;
  var SHIPPING_PROTECTION_VARIANT_ID = 55980472533316;
  var JEWELRY_CAD_PRODUCT_ID = 8631210705220;
  var FREE_GIFT_VARIANTS = [
    47888833249604,
    49312480854340,
    55197681484100,
    49312485179716
  ];

  var res = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
  var cart = await res.json();

  var realItems = [];
  (cart.items || []).forEach(function (item) {
    var vid = Number(item.variant_id);
    var pid = Number(item.product_id);
    
    // Skip free gifts, VIP gift, shipping protection, and jewelry CAD
    if (vid === Number(VIP_GIFT_VARIANT_ID)) return;
    if (vid === Number(SHIPPING_PROTECTION_VARIANT_ID)) return;
    if (pid === Number(JEWELRY_CAD_PRODUCT_ID)) return;
    if (FREE_GIFT_VARIANTS.indexOf(vid) !== -1) return;
    if (!item.price || item.price <= 0) return;
    
    // This is a real item - record it
    realItems.push({
      variant_id: item.variant_id,
      quantity: item.quantity,
      properties: item.properties || {}
    });
  });

  return realItems;
}

/**
 * Add back the real items that were recorded before coupon removal
 * @param {Array} realItems - Array of items from recordRealItems()
 */
async function addBackRealItems(realItems) {
  if (!realItems || realItems.length === 0) return;

  // Build items array for /cart/add.js
  var items = realItems.map(function (item) {
    return {
      id: item.variant_id,
      quantity: item.quantity,
      properties: item.properties
    };
  });

  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    credentials: 'same-origin',
    cache: 'no-store',
    body: JSON.stringify({ items: items })
  });
}

function bindRemoveCoupon(context) {
  var root = context || document;

  if (root.__removeCouponBound) return;
  root.__removeCouponBound = true;

  function setCookie(name, value, days) {
    var expires = "";
    if (days !== undefined) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax";
  }

  function deleteCookie(name) {
    // delete for current domain
    document.cookie = name + "=; Max-Age=0; path=/; SameSite=Lax";
    // delete for dot domain (common in Shopify)
    document.cookie = name + "=; Max-Age=0; path=/; domain=." + location.hostname.replace(/^www\./, "") + "; SameSite=Lax";
  }

  async function refreshDrawerHard() {
    if (typeof refreshCartDrawer === 'function') {
      await refreshCartDrawer({ silent: false });
      return;
    }

    // fallback: fetch section directly
    const res = await fetch('/?sections=cart-drawer', { credentials: 'same-origin', cache: 'no-store' });
    const json = await res.json();
    var sectionHtml =
      (json.sections && json.sections['cart-drawer']) || json['cart-drawer'];
    if (window.cartDrawer && sectionHtml) {
      cartDrawer.render(sectionHtml, 'cart-drawer');
      window.dispatchEvent(new CustomEvent('cart:updated'));
    }
  }

  root.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-remove-coupon]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var messageContainer = document.getElementById('discount-message');

    function show(msg, type) {
      if (!messageContainer) return;
      messageContainer.innerText = msg;
      messageContainer.style.color =
        type === 'error' ? 'red' :
        type === 'success' ? 'green' : '';
    }

    btn.disabled = true;
    btn.classList.add('is-removing');
    btn.setAttribute('aria-busy', 'true');
    show('Removing coupon...');

    try {
      // 1) ✅ NEW: Record all real items before doing anything
      var realItems = await recordRealItems();

      // 2) Clear Shopify discount session
      await fetch('/discount/clear?redirect=/', {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      // 3) Clear the cookie signals YOUR vipCookiePresent() checks
      deleteCookie('discount');
      deleteCookie('discount_code');
      deleteCookie('checkout_discount_code');

      // Also clear Shopify's common discount cookie names (best effort)
      deleteCookie('cart_currency');
      deleteCookie('cart');
      deleteCookie('_shopify_sa_t');
      deleteCookie('_shopify_sa_p');

      // 4) ✅ CHANGED: Clear entire cart (cleaner approach)
      await fetch('/cart/clear', {
        method: 'POST',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'Content-Type': 'application/json' }
      });

      // Small delay to ensure cart is cleared
      await new Promise(function (r) { setTimeout(r, 500); });

      // 5) ✅ NEW: Add back the real items
      if (realItems.length > 0) {
        await addBackRealItems(realItems);
      }

      // 6) Refresh the drawer so Liquid shows updated state
      await new Promise(function (r) { setTimeout(r, 700); });
      await refreshDrawerHard();

      // 7) Stop auto re-adding VIP gifts after removal
      window.__vipGiftBusy = false;
      window.__vipGiftDisabledUntil = Date.now() + 5000;

      show('Coupon removed.', 'success');
    } catch (err) {
      console.error('[CouponRemove] failed:', err);
      show('Failed to remove coupon. Please try again.', 'error');
    } finally {
      btn.disabled = false;
      btn.classList.remove('is-removing');
      btn.removeAttribute('aria-busy');
    }
  });
}

function bindShippingProtectionModal(context) {
  var root = context || document;
  var modal = root.querySelector('[data-shipping-protection-modal]');
  var backdrop = root.querySelector('[data-shipping-protection-modal-backdrop]');
  if (!modal || !backdrop) return;

  function openModal() {
    modal.classList.add('open');
    backdrop.classList.add('open');
  }

  function closeModal() {
    modal.classList.remove('open');
    backdrop.classList.remove('open');
  }

  root.querySelectorAll('[data-open-shipping-protection-modal]').forEach(function (btn) {
    if (btn.__spModalBound) return;
    btn.__spModalBound = true;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openModal();
    });
  });

  root.querySelectorAll('[data-close-shipping-protection-modal]').forEach(function (btn) {
    if (btn.__spModalCloseBound) return;
    btn.__spModalCloseBound = true;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      closeModal();
    });
  });

  if (!backdrop.__spBackdropBound) {
    backdrop.__spBackdropBound = true;
    backdrop.addEventListener('click', function () {
      closeModal();
    });
  }
}

function bindShippingProtectionToggle(context) {
  var root = context || document;
  var row = root.querySelector('[data-shipping-protection]');
  if (!row) return;

  var toggle = row.querySelector('.shipping-protection-toggle');
  if (!toggle || toggle.__spToggleBound) return;
  toggle.__spToggleBound = true;

  toggle.addEventListener('click', function () {
    var variantId = row.getAttribute('data-variant-id');
    if (!variantId) return;

    var inCart = row.getAttribute('data-in-cart') === 'true';

    if (!window.__shippingProtectionUserInteracted) {
      window.__shippingProtectionUserInteracted = true;
    }

    var nextState = !inCart;
    row.setAttribute('data-in-cart', String(nextState));
    toggle.classList.toggle('is-on', nextState);
    toggle.setAttribute('aria-pressed', String(nextState));
    toggle.classList.add('is-busy');

    var actionPromise;

    if (!inCart) {
      if (typeof addToCart === 'function') {
        actionPromise = addToCart(
          [{ id: Number(variantId), quantity: 1 }],
          { silent: true, source: 'shipping-protection-toggle' }
        );
      } else {
        console.warn('addToCart helper not found');
        actionPromise = Promise.resolve();
      }
    } else {
      if (typeof removeFromCart === 'function') {
        actionPromise = removeFromCart(
          [Number(variantId)],
          { silent: true, source: 'shipping-protection-toggle' }
        );
      } else {
        console.warn('removeFromCart helper not found');
        actionPromise = Promise.resolve();
      }
    }

    Promise.resolve(actionPromise)
      .catch(function (err) {
        console.error(err);
        row.setAttribute('data-in-cart', String(inCart));
        toggle.classList.toggle('is-on', inCart);
        toggle.setAttribute('aria-pressed', String(inCart));
      })
      .finally(function () {
        toggle.classList.remove('is-busy');
      });
  });
}

async function ensureShippingProtectionDefaultOn(context) {
  var root = context || document;
  var row = root.querySelector('[data-shipping-protection]');
  if (!row) return;

  if (window.__shippingProtectionUserInteracted) return;

  // ✅ Don't auto-add if we're in the process of removing last items
  if (window.__preventShippingProtectionAutoAdd) {
    return;
  }

  var variantId = row.getAttribute('data-variant-id');
  var toggle = row.querySelector('.shipping-protection-toggle');
  if (!variantId || !toggle) return;

  try {
    const cartRes = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
    const cart = await cartRes.json();

    // ✅ Check if shipping protection is already in cart
    const spInCart = (cart.items || []).some(item => String(item.variant_id) === variantId);
    if (spInCart) {
      row.setAttribute('data-in-cart', 'true');
      toggle.classList.add('is-on');
      toggle.setAttribute('aria-pressed', 'true');
      return;
    }

    // ✅ IMPORTANT: Verify there are actual real items before auto-adding shipping protection
    const shipping = 55980472533316;
    const vipProductId = 49312485179716; // VIP Tennis Chain
    const jewelryCADProductId = 8631210705220;
    
    const hasRealItems = cart.items.some(item => {
      const vid = String(item.variant_id);
      if (vid === String(shipping)) return false;
      if (vid === String(vipProductId)) return false;
      if (String(item.product_id) === String(jewelryCADProductId)) return false;
      if (!item.price || item.price <= 0) return false;
      return true;
    });
    
    if (!hasRealItems) {
      return;
    }
  } catch (err) {
    console.error('[ShippingProtection] Failed to check cart status:', err);
    return;
  }

  row.setAttribute('data-in-cart', 'true');
  toggle.classList.add('is-on');
  toggle.setAttribute('aria-pressed', 'true');
  toggle.classList.add('is-busy');

  var actionPromise;
  if (typeof addToCart === 'function') {
    actionPromise = addToCart([{ id: Number(variantId), quantity: 1 }], { silent: true, source: 'shipping-protection-default' });
  } else {
    console.warn('addToCart helper not found for default Shipping Protection add');
    actionPromise = Promise.resolve();
  }

  Promise.resolve(actionPromise)
    .catch(function (err) {
      console.error('[ShippingProtection] Failed to auto-add:', err);
      row.setAttribute('data-in-cart', 'false');
      toggle.classList.remove('is-on');
      toggle.setAttribute('aria-pressed', 'false');
    })
    .finally(function () {
      toggle.classList.remove('is-busy');
    });
}

(function () {
  var cartDrawerEl = document.querySelector('cart-drawer');
  if (!cartDrawerEl) return;

  cartDrawer = cartDrawerEl;
  window.cartDrawer = cartDrawerEl;
  window.closeCartDrawer = function () { cartDrawer.close(); };

  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      if (!this.__boundUpsellDirectAdd) {
        this.__boundUpsellDirectAdd = true;
        this.addEventListener('click', this.onCartUpsellDirectAddClick.bind(this));
      }

      this.populateUpsells();

      this.overlay = document.querySelector('.cart-drawer-overlay');
      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }

      var closeBtn = document.querySelector('[data-close-cart]');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          this.close();
          document.querySelector('[data-open-cart]').focus();
        });
      }

      this.querySelectorAll('[data-item-remove]').forEach((el) => {
        el.addEventListener('click', () => this.removeItem(el));
      });

      this.querySelectorAll('[data-item-increment]').forEach((el) => {
        el.addEventListener('click', () => this.incrementItem(el));
      });

      this.querySelectorAll('[data-item-decrement]').forEach((el) => {
        el.addEventListener('click', () => this.decrementItem(el));
      });

      this.mergeDuplicatePaidLines();

      if (typeof bindDiscountForm === 'function') bindDiscountForm();
      if (typeof bindRemoveCoupon === 'function') bindRemoveCoupon(this);
      if (typeof bindShippingProtectionModal === 'function') bindShippingProtectionModal(this);
      if (typeof bindShippingProtectionToggle === 'function') bindShippingProtectionToggle(this);
      if (typeof ensureShippingProtectionDefaultOn === 'function') ensureShippingProtectionDefaultOn(this);

      if (window.scheduleAffirmRefresh) window.scheduleAffirmRefresh('cart-drawer-init');
      else if (window.affirm?.ui?.refresh) affirm.ui.refresh();
    }

    // A Buy X Get Y discount can rebuild the cart's lines for a product into
    // several separate paid lines (each its own quantity 1) instead of one
    // line with a higher quantity, every time the total quantity changes.
    // That's server-side behavior we don't control. This just cleans up how
    // it's *displayed*: collapse duplicate paid lines for the same
    // variant+properties into a single row with a combined quantity, so the
    // customer never sees the same product listed twice. +/- still act on
    // the first (primary) line's own quantity; the remove button is taught
    // to zero out every line in the group.
    mergeDuplicatePaidLines() {
      var groups = {};

      this.querySelectorAll('.cart-drawer__item[data-final-price]').forEach((el) => {
        var finalPrice = Number(el.dataset.finalPrice);
        if (!finalPrice || finalPrice <= 0) return; // skip free/gift lines

        var groupKey = (el.dataset.variantId || '') + '::' + (el.dataset.propertiesKey || '');
        (groups[groupKey] = groups[groupKey] || []).push(el);
      });

      Object.keys(groups).forEach((groupKey) => {
        var group = groups[groupKey];
        if (group.length < 2) return;

        var primary = group[0];
        var totalQty = group.reduce((sum, el) => sum + Number(el.dataset.quantity || 0), 0);

        primary.dataset.mergedKeys = JSON.stringify(group.map((el) => el.dataset.itemId));

        var qtyEl = primary.querySelector('.cd__item-quantity-number');
        if (qtyEl) qtyEl.textContent = totalQty;

        for (var i = 1; i < group.length; i++) {
          group[i].style.display = 'none';
          group[i].setAttribute('aria-hidden', 'true');
        }
      });
    }

    // async populateUpsells() {
    //   var upsellsRoot = this.querySelector('.cd-upsells');
    //   if (!upsellsRoot) return;

    //   var mostRecentItem = upsellsRoot.dataset.mostRecentItem || '8688404627780';

    //   try {
    //     var res = await fetch(
    //       window.Shopify.routes.root +
    //       'recommendations/products?product_id=' +
    //       mostRecentItem +
    //       '&limit=3&section_id=cart-drawer-recommendations&intent=related'
    //     );
    //     var html = await res.text();
    //     var parser = new DOMParser();
    //     var doc = parser.parseFromString(html, 'text/html');
    //     var inner = doc.querySelector('.cd-upsells');
    //     if (inner) upsellsRoot.innerHTML = inner.innerHTML;
    //   } catch (e) {
    //     console.warn('Failed to load cart upsells:', e);
    //   }

    //   var selections = document.querySelectorAll('.cd-upsell-selection');

    //   document.addEventListener('click', (e) => {
    //     if (e.target.dataset.triggerSelection) {
    //       selections.forEach((selection) => selection.classList.remove('open'));
    //       var container = e.target.closest('cart-drawer');
    //       if (!container) return;
    //       var target = container.querySelector('[data-selection="' + e.target.dataset.triggerSelection + '"]');
    //       if (target) target.classList.add('open');
    //     }
    //     if (!e.target.closest('.size-chart__popup') && !e.target.closest('.cd-upsell-selection') && !e.target.closest('.cd-upsell')) {
    //       selections.forEach((selection) => selection.classList.remove('open'));
    //     }
    //     if (e.target.classList.contains('cd-selection-close')) {
    //       selections.forEach((selection) => selection.classList.remove('open'));
    //     }
    //   });
    // }

    async populateUpsells() {
      var upsellsRoot = this.querySelector('.cd-upsells');
      if (!upsellsRoot) return;

      var mostRecentItem = upsellsRoot.dataset.mostRecentItem || '8688404627780';
      if (upsellsRoot.getAttribute('data-upsells-loaded') === String(mostRecentItem)) return;

      try {
        var res = await fetch(
          window.Shopify.routes.root +
          'recommendations/products?product_id=' +
          mostRecentItem +
          '&limit=3&section_id=cart-drawer-recommendations&intent=related'
        );
        var html = await res.text();
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var inner = doc.querySelector('.cd-upsells');
        if (inner) {
          upsellsRoot.innerHTML = inner.innerHTML;
          upsellsRoot.setAttribute('data-upsells-loaded', String(mostRecentItem));

          // Fire impression events for every upsell variant now visible
          var visibleBtns = upsellsRoot.querySelectorAll('[data-upsell-direct-add]');
          var visibleVariantIds = [];
          visibleBtns.forEach(function (btn) {
            var vid = btn.getAttribute('data-upsell-direct-add');
            if (vid && visibleVariantIds.indexOf(vid) === -1) visibleVariantIds.push(vid);
          });
          if (visibleVariantIds.length > 0) {
            try {
              var visitorId = getVisitorId();
              var shopDomain = (window.Shopify && window.Shopify.shop) ? window.Shopify.shop : 'icecartel.myshopify.com';
              fetch('https://drawer-analytics-production.up.railway.app/api/track?shop=' + shopDomain, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ event_type: 'impression', variant_ids: visibleVariantIds, session_id: visitorId })
              }).catch(function (err) { console.warn('[DA] Impression track failed:', err); });
            } catch (err) {
              console.warn('[DA] Impression track error:', err);
            }
          }
        }
      } catch (e) {
        console.warn('Failed to load cart upsells:', e);
      }

      var selections = document.querySelectorAll('.cd-upsell-selection');

      document.addEventListener('click', (e) => {
        if (e.target.dataset.triggerSelection) {
          selections.forEach((selection) => selection.classList.remove('open'));
          var container = e.target.closest('cart-drawer');
          if (!container) return;
          var target = container.querySelector('[data-selection="' + e.target.dataset.triggerSelection + '"]');
          if (target) target.classList.add('open');
        }
        if (!e.target.closest('.size-chart__popup') && !e.target.closest('.cd-upsell-selection') && !e.target.closest('.cd-upsell')) {
          selections.forEach((selection) => selection.classList.remove('open'));
        }
        if (e.target.classList.contains('cd-selection-close')) {
          selections.forEach((selection) => selection.classList.remove('open'));
        }
      });
    }

    async incrementItem(el) {
      const id = this.getId(el);
      const currentQty = this.getQuantity(el);
      const newQty = currentQty + 1;
      
      if (typeof changeItemQuantity === 'function') {
        await changeItemQuantity(id, newQty);
      }
    }

    async decrementItem(el) {
      const id = this.getId(el);
      const currentQty = this.getQuantity(el);
      const newQty = currentQty - 1;
      
      if (typeof changeItemQuantity === 'function') {
        await changeItemQuantity(id, newQty);
      }
    }

    getQuantity(el) {
      return Number(el.closest('.cart-drawer__item').dataset.quantity);
    }

    getId(el) {
      return el.closest('.cart-drawer__item').dataset.itemId;
    }

    getMergedKeys(el) {
      var wrapper = el.closest('.cart-drawer__item');
      var raw = wrapper && wrapper.dataset.mergedKeys;
      if (!raw) return [this.getId(el)];
      try {
        var parsed = JSON.parse(raw);
        return Array.isArray(parsed) && parsed.length ? parsed : [this.getId(el)];
      } catch (e) {
        return [this.getId(el)];
      }
    }

    async removeItem(el) {
      const keys = this.getMergedKeys(el);

      if (typeof changeItemQuantity === 'function') {
        for (const key of keys) {
          await changeItemQuantity(key, 0);
        }
      }
    }

    onCartUpsellDirectAddClick(e) {
      var btn = e.target.closest('[data-upsell-direct-add]');
      if (!btn || !this.contains(btn)) return;
      e.preventDefault();
      var vid = btn.getAttribute('data-upsell-direct-add');
      if (!vid) return;

      // Track upsell add-to-cart with session ID for attribution (fire-and-forget)
      try {
        var visitorId = getVisitorId();
        var shopDomain = (window.Shopify && window.Shopify.shop) ? window.Shopify.shop : 'icecartel.myshopify.com';
        console.log('[DA] Tracking upsell add-to-cart', { variant_id: vid, session_id: visitorId, shop: shopDomain });
        fetch('https://drawer-analytics-production.up.railway.app/api/track?shop=' + shopDomain, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ variant_id: vid, session_id: visitorId })
        }).then(function(res) {
          console.log('[DA] Track response status:', res.status);
          return res.json();
        }).then(function(data) {
          console.log('[DA] Track response:', data);
        }).catch(function(err) {
          console.error('[DA] Track fetch failed:', err);
        });
        // Save session ID as cart attribute so it travels with the order
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { _da_session: visitorId } })
        }).then(function() {
          console.log('[DA] Cart attribute _da_session set:', visitorId);
        }).catch(function(err) {
          console.error('[DA] Cart attribute update failed:', err);
        });
      } catch (err) {
        console.error('[DA] Tracking error:', err);
      }

      this.classList.add('loading');
      var self = this;
      var p =
        typeof addToCart === 'function'
          ? addToCart([{ id: Number(vid), quantity: 1 }], { silent: false })
          : Promise.reject(new Error('addToCart unavailable'));
      Promise.resolve(p)
        .catch(function (err) {
          console.warn('[Cart upsell] Direct add failed:', err);
        })
        .finally(function () {
          self.classList.remove('loading');
        });
    }

    open() {
      this.classList.add('open');
      if (this.overlay) this.overlay.classList.add('open');
    }

    close() {
      this.classList.remove('open');
      if (this.overlay) this.overlay.classList.remove('open');
    }

    cancelScrollRestore() {
      var restore = this.__scrollRestore;
      if (!restore) return;
      this.__scrollRestore = null;
      restore.cancel();
    }

    restoreScroll(prevTop) {
      this.cancelScrollRestore();

      var scroller = this.querySelector('.cart-drawer-scroll-container');
      if (!scroller) return;

      var self = this;
      var stopped = false;
      var observer = null;
      var poll = 0;
      var rafId = 0;
      var startedAt = Date.now();
      var lastHeight = -1;
      var stableSince = Date.now();

      var apply = function () {
        if (stopped || !scroller.isConnected) return;
        scroller.scrollTop = prevTop;
      };

      var stop = function () {
        if (stopped) return;
        stopped = true;
        if (rafId) cancelAnimationFrame(rafId);
        if (poll) clearInterval(poll);
        if (observer) observer.disconnect();
        scroller.removeEventListener('wheel', stop);
        scroller.removeEventListener('touchstart', stop);
        scroller.removeEventListener('keydown', stop);
        scroller.removeEventListener('load', onLayout, true);
        if (self.__scrollRestore && self.__scrollRestore.cancel === stop) {
          self.__scrollRestore = null;
        }
      };

      // Upsells and Splide mount after the HTML swap and shrink the list first,
      // which clamps scrollTop. Keep the original target until that height
      // comes back. Stop 2.5s after the target is actually holding, or at 8s.
      var onLayout = function () {
        stableSince = Date.now();
        apply();
      };

      var tick = function () {
        if (stopped || !scroller.isConnected) return;
        apply();
        var height = scroller.scrollHeight;
        var now = Date.now();
        if (height !== lastHeight) {
          lastHeight = height;
          stableSince = now;
        }
        var maxTop = Math.max(0, scroller.scrollHeight - scroller.clientHeight);
        var holdingTarget = maxTop + 1 >= prevTop && scroller.scrollTop >= prevTop - 1;
        if (holdingTarget && now - stableSince >= 2500) stop();
        else if (now - startedAt >= 8000) stop();
      };

      this.__scrollRestore = { cancel: stop, target: prevTop };

      apply();
      rafId = requestAnimationFrame(apply);

      if (typeof ResizeObserver === 'function') {
        observer = new ResizeObserver(onLayout);
        Array.prototype.forEach.call(scroller.children, function (child) {
          observer.observe(child);
        });
      }

      scroller.addEventListener('load', onLayout, true);
      poll = setInterval(tick, 100);
      scroller.addEventListener('wheel', stop, { passive: true });
      scroller.addEventListener('touchstart', stop, { passive: true });
      scroller.addEventListener('keydown', stop);
    }

    holdRenders() {
      this.__renderHolds = (this.__renderHolds || 0) + 1;
    }

    releaseRenders() {
      this.__renderHolds = Math.max(0, (this.__renderHolds || 1) - 1);
      if (this.__renderHolds > 0 || !this.__heldRender) return;
      var held = this.__heldRender;
      this.__heldRender = null;
      this.applyRender(held.html, held.selector);
    }

    render(html, selector) {
      if (this.__renderHolds > 0) {
        this.__heldRender = { html: html, selector: selector };
        return;
      }
      this.applyRender(html, selector);
    }

    applyRender(html, selector) {
      var scroller = this.querySelector('.cart-drawer-scroll-container');
      var liveTop = scroller ? scroller.scrollTop : 0;
      var wasOpen = this.classList.contains('open');
      // A render while the fresh HTML is still short clamps scrollTop. Keep the
      // position the user actually set until they scroll themselves.
      var pendingTarget = this.__scrollRestore && this.__scrollRestore.target;
      var prevTop = typeof pendingTarget === 'number' ? pendingTarget : liveTop;
      var prevUpsells = this.querySelector('.cd-upsells');
      var prevUpsellHtml = prevUpsells ? prevUpsells.innerHTML : '';
      var prevUpsellId = prevUpsells ? prevUpsells.getAttribute('data-most-recent-item') : '';
      var prevUpsellsLoaded = prevUpsells ? prevUpsells.getAttribute('data-upsells-loaded') : '';
      this.cancelScrollRestore();

      this.classList.remove('loading');
      this.innerHTML = this.getSectionInnerHTML(html, selector);

      var nextUpsells = this.querySelector('.cd-upsells');
      if (
        nextUpsells &&
        prevUpsellHtml &&
        prevUpsellsLoaded &&
        String(nextUpsells.getAttribute('data-most-recent-item') || '') === String(prevUpsellId || '')
      ) {
        nextUpsells.innerHTML = prevUpsellHtml;
        nextUpsells.setAttribute('data-upsells-loaded', prevUpsellsLoaded);
      }

      this.init();

      if (wasOpen && prevTop > 0) this.restoreScroll(prevTop);

      if (typeof window.iceCurrencyApplyPrices === 'function') window.iceCurrencyApplyPrices();

      if (window.scheduleAffirmRefresh) window.scheduleAffirmRefresh('cart-drawer-render');
      else if (window.affirm?.ui?.refresh) affirm.ui.refresh();
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
      return [{ id: 'cart-drawer', selector: 'cart-drawer' }];
    }
  }

  customElements.define('cart-drawer', CartDrawer);

  if (window.__pendingCartOpen && typeof cartDrawer.open === 'function') {
    cartDrawer.open();
    window.__pendingCartOpen = false;
  }
})();